import { Phone, MapPin, Clock, ArrowRight } from "lucide-react";
import { COMPANY } from "@/data/services";

export default function Contact() {
  return (
    <section id="contact" className="py-20 lg:py-28 bg-slate-50" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-6">
          <a href={COMPANY.phoneHref} className="bg-white border border-slate-200 rounded-lg p-8 hover:-translate-y-1 hover:shadow-md transition-all duration-200" data-testid="contact-phone-card">
            <div className="h-12 w-12 rounded-lg bg-blue-50 flex items-center justify-center mb-4">
              <Phone className="h-6 w-6 text-accent" strokeWidth={1.5} />
            </div>
            <h3 className="font-display font-semibold text-lg text-slate-900">Call Us</h3>
            <p className="text-2xl font-display font-extrabold text-accent mt-1">{COMPANY.phoneDisplay}</p>
            <p className="text-slate-500 text-sm">{COMPANY.phoneSub}</p>
            <p className="text-slate-500 text-sm mt-2 break-all">{COMPANY.email}</p>
            <p className="text-accent text-sm font-semibold mt-1">{COMPANY.website}</p>
          </a>

          <div className="bg-white border border-slate-200 rounded-lg p-8">
            <div className="h-12 w-12 rounded-lg bg-blue-50 flex items-center justify-center mb-4">
              <MapPin className="h-6 w-6 text-accent" strokeWidth={1.5} />
            </div>
            <h3 className="font-display font-semibold text-lg text-slate-900">Service Area</h3>
            <p className="text-slate-500 mt-1">Greater Houston, TX and surrounding areas. Commercial & residential.</p>
          </div>

          <div className="bg-white border border-slate-200 rounded-lg p-8">
            <div className="h-12 w-12 rounded-lg bg-blue-50 flex items-center justify-center mb-4">
              <Clock className="h-6 w-6 text-accent" strokeWidth={1.5} />
            </div>
            <h3 className="font-display font-semibold text-lg text-slate-900">Hours</h3>
            <p className="text-slate-500 mt-1">Mon–Fri 7am–6pm · Sat 8am–2pm</p>
            <p className="text-slate-500 text-sm">Online booking 24/7</p>
          </div>
        </div>

        <div className="mt-12 bg-accent rounded-2xl p-10 text-center text-white">
          <h3 className="text-2xl md:text-3xl font-display font-bold">Ready to Get Started?</h3>
          <p className="mt-2 text-blue-100">Book your service call online in under two minutes.</p>
          <a href="#book" data-testid="contact-book-cta" className="mt-6 inline-flex items-center gap-2 bg-white text-accent font-semibold px-7 py-4 rounded-md hover:bg-blue-50 transition-colors">
            Book a Service <ArrowRight className="h-5 w-5" />
          </a>
        </div>
      </div>
    </section>
  );
}
